import React from "react";
import prrImage from "../BARRA_ACORES_PRR_FUNDO_PRETO.png";
import "../App.css";

/** Minimal brand-gradient footer carrying the mandatory PRR funding bar. */
function Footer() {
  return (
    <footer className="app-footer">
      <a
        href="https://recuperarportugal.gov.pt/"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
      >
        <img
          src={prrImage}
          alt="Financiado pela União Europeia - PRR"
          className="footer-image"
        />
      </a>
    </footer>
  );
}

export default Footer;
